/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `weather_alert` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class WeatherAlertMesg : Mesg {
    public constructor() : super("WeatherAlert", Profile.MesgNum.WEATHER_ALERT)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** timestamp. */
    public var timestamp: Instant?
        get() = (getFieldValue(TIMESTAMP_FIELD_NUM) as? UInt)?.let { FitDateTime.toInstant(it) }
        set(value) = setFieldValue(TIMESTAMP_FIELD_NUM, value?.let { FitDateTime.toTimestamp(it) })

    /** report_id. Unique identifier from GCS report ID string, length is 12 */
    public var reportId: String?
        get() = getFieldValue(REPORT_ID_FIELD_NUM) as? String
        set(value) = setFieldValue(REPORT_ID_FIELD_NUM, value)

    /** issue_time. Time alert was issued */
    public var issueTime: Instant?
        get() = (getFieldValue(ISSUE_TIME_FIELD_NUM) as? UInt)?.let { FitDateTime.toInstant(it) }
        set(value) = setFieldValue(ISSUE_TIME_FIELD_NUM, value?.let { FitDateTime.toTimestamp(it) })

    /** expire_time. Time alert expires */
    public var expireTime: Instant?
        get() = (getFieldValue(EXPIRE_TIME_FIELD_NUM) as? UInt)?.let { FitDateTime.toInstant(it) }
        set(value) = setFieldValue(EXPIRE_TIME_FIELD_NUM, value?.let { FitDateTime.toTimestamp(it) })

    /** severity. Warning, Watch, Advisory, Statement */
    public var severity: WeatherSeverity?
        get() = (getFieldValue(SEVERITY_FIELD_NUM) as? UByte)?.let { WeatherSeverity.fromValue(it) }
        set(value) = setFieldValue(SEVERITY_FIELD_NUM, value?.value)

    /** type. Tornado, Severe Thunderstorm, etc. */
    public var type: WeatherSevereType?
        get() = (getFieldValue(TYPE_FIELD_NUM) as? UByte)?.let { WeatherSevereType.fromValue(it) }
        set(value) = setFieldValue(TYPE_FIELD_NUM, value?.value)

    public companion object {
        public const val TIMESTAMP_FIELD_NUM: UByte = 253u
        public const val REPORT_ID_FIELD_NUM: UByte = 0u
        public const val ISSUE_TIME_FIELD_NUM: UByte = 1u
        public const val EXPIRE_TIME_FIELD_NUM: UByte = 2u
        public const val SEVERITY_FIELD_NUM: UByte = 3u
        public const val TYPE_FIELD_NUM: UByte = 4u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[253] = Field("Timestamp", 253u, BaseType.UINT32, 1.0, 0.0, "", false)
            fields[0] = Field("ReportId", 0u, BaseType.STRING, 1.0, 0.0, "", false)
            fields[1] = Field("IssueTime", 1u, BaseType.UINT32, 1.0, 0.0, "", false)
            fields[2] = Field("ExpireTime", 2u, BaseType.UINT32, 1.0, 0.0, "", false)
            fields[3] = Field("Severity", 3u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[4] = Field("Type", 4u, BaseType.ENUM, 1.0, 0.0, "", false)
            return fields
        }
    }
}
